import { client } from "api";
import { PhotoComment } from "models/PhotoComment";

export type EditPhotoCommentRequest = { commentId: string; newComment: string; mediaId: string };
export type EditPhotoCommentResponse = PhotoComment;

export const editPhotoComment = (request: EditPhotoCommentRequest) =>
  client
    .patch<EditPhotoCommentResponse>(`/bin/edit-photo-comment`, request)
    .then((res) => res.data);
